/* tslint:disable */
/* eslint-disable */
/**
 * Client Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * A payload containing resourceIds to be removed from multiple clients
 * @export
 * @interface RemoveAssociations
 */
export interface RemoveAssociations {
    /**
     * 
     * @type {Array<string>}
     * @memberof RemoveAssociations
     */
    subjectRIDs?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof RemoveAssociations
     */
    clientRIDs?: Array<string>;
}

/**
 * Check if a given object implements the RemoveAssociations interface.
 */
export function instanceOfRemoveAssociations(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function RemoveAssociationsFromJSON(json: any): RemoveAssociations {
    return RemoveAssociationsFromJSONTyped(json, false);
}

export function RemoveAssociationsFromJSONTyped(json: any, ignoreDiscriminator: boolean): RemoveAssociations {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'subjectRIDs': !exists(json, 'subjectRIDs') ? undefined : json['subjectRIDs'],
        'clientRIDs': !exists(json, 'clientRIDs') ? undefined : json['clientRIDs'],
    };
}

export function RemoveAssociationsToJSON(value?: RemoveAssociations | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'subjectRIDs': value.subjectRIDs,
        'clientRIDs': value.clientRIDs,
    };
}

